import type { Badge } from '@/types/common'

// TODO: expand with badge icons, requirements, rewards

export interface BadgeMeta {
  id: Badge
  name: string
  description: string
  icon: string
}

export const BADGES: Record<Badge, BadgeMeta> = {
  FirstPlant: {
    id: 'FirstPlant',
    name: 'Green Thumb',
    description: 'Added your first plant',
    icon: 'seedling',
  },
  FirstCreature: {
    id: 'FirstCreature',
    name: 'Creator',
    description: 'Generated your first creature',
    icon: 'sparkles',
  },
  FirstGame: {
    id: 'FirstGame',
    name: 'Player One',
    description: 'Played your first game',
    icon: 'gamepad',
  },
  CareStreak7: {
    id: 'CareStreak7',
    name: 'Dedicated',
    description: '7-day care streak',
    icon: 'fire',
  },
  CareStreak30: {
    id: 'CareStreak30',
    name: 'Devoted',
    description: '30-day care streak',
    icon: 'trophy',
  },
  AllElements: {
    id: 'AllElements',
    name: 'Elemental',
    description: 'Collected all 4 elements',
    icon: 'globe',
  },
  Collector10: {
    id: 'Collector10',
    name: 'Collector',
    description: 'Collected 10 creatures',
    icon: 'collection',
  },
  GameWinner: {
    id: 'GameWinner',
    name: 'Champion',
    description: 'Won a multiplayer game',
    icon: 'crown',
  },
}
